export const MC_RAW_DATA_LIST_REQUEST = "MC_RAW_DATA_LIST_REQUEST";
export const MC_RAW_DATA_LIST_SUCCESS = "MC_RAW_DATA_LIST_SUCCESS";
export const MC_RAW_DATA_LIST_FAILED = "MC_RAW_DATA_LIST_FAILED";
